import type { Bell } from 'services/api';

export const getUniqueBells = (bells: Bell[]) => {
  const uniqueBells: Bell[] = [];

  bells.forEach((bell) => {
    if (
      !uniqueBells.some(
        (uniqueBell) =>
          uniqueBell.startTime === bell.startTime && uniqueBell.endTime === bell.endTime,
      )
    ) {
      uniqueBells.push(bell);
    }
  });

  return uniqueBells;
};
